import { Component, OnInit, Input } from '@angular/core';
import { CustomerModel } from '@admin/customers/shared/models/customer-model';
import { CustomerService } from '../shared/services/customer.service';
import { CustomMessageService } from '@admin/core/message.service';
import { UserService } from '@admin/core/user.service';
import { MessageType } from '@admin/core/models/enum/message-type';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { FeatureEnum } from '../../shared/models/feature-enum';
import { ActionResultModel } from '../../shared/models/action-result-model';
import { CustomerEventModel } from '@admin/customers/shared/models/customer-event-model';
import { StoreItemModel } from '@admin/product-purchases/shared/models/store-item-model';
import { StoreService } from '@admin/product-purchases/shared/services/store-service.service';
import { ProductType } from '@admin/product-purchases/shared/models/product-type';
import { CustomerStatusEnum } from '@admin/customers/shared/models/customer-status.enum';

@Component({
  selector: 'hr-customer-events',
  templateUrl: './customer-events.component.html',
  styleUrls: ['./customer-events.component.less'],
  standalone: false,
})
export class CustomerEventsComponent implements OnInit {
  @Input()
  public customer: CustomerModel;

  public customerStatusEnum: any = CustomerStatusEnum;

  public hasManageJobFairsPermission: boolean;

  public addModeOn: boolean;
  public requestModeOn: boolean;

  public storeItems: StoreItemModel[];
  public selectedParticipant: CustomerEventModel;

  constructor(
    private customerService: CustomerService,
    private storeService: StoreService,
    private messageService: CustomMessageService,
    private userService: UserService
  ) {
    this.hasManageJobFairsPermission = false;
    this.addModeOn = false;
    this.requestModeOn = false;
  }

  onDelete(eventId: number) {
    this.customerService
      .deleteCustomerEvent(this.customer.customerId, eventId)
      .subscribe((r) => {
        if (r.success) {
          if (r.message != null)
            this.showMessage(r.message, MessageType.Success);
          this.refresh();
        } else {
          this.showMessage(r.message, MessageType.Error);
        }
      });
  }

  private refresh() {
    // TODO: should emit and reload customer from parent component
    window.location.reload();
  }

  onAdd() {
    this.addModeOn = true;
  }

  onRequestEventCvDatabaseAccess(customerEvent: CustomerEventModel) {
    this.storeService
      .listEventRelatedStockItems(
        ProductType.EventCvDatabaseAccess,
        customerEvent.eventId
      )
      .subscribe((d) => {
        this.storeItems = d.items;
        this.selectedParticipant = customerEvent;
        this.requestModeOn = true;
      });
  }

  public onUpdateTable(result: ActionResultModel) {
    this.addModeOn = false;
    this.requestModeOn = false;

    if (result != null) {
      if (result.success) {
        this.showMessage(result.message, MessageType.Success);
        this.refresh();
      } else if (result.message != null) {
        this.showMessage(result.message, MessageType.Error);
      }
    }
  }

  ngOnInit() {
    this.hasManageJobFairsPermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.ManageJobFairs
      );
  }

  private showMessage(message: string, type: MessageType) {
    if (message != null && message.length > 0) {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: type,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: message,
      });
    }
  }
}
